<ras-page [show_heading]="true">

	<ras-image-banner *ngIf="banner" [image]="banner.image" [imageWebp]="banner.imageWebp" [position]="banner.position" [focusX]="banner.focusX" [focusY]="banner.focusY" [topText]="banner.topText" [topText2]="banner.topText2" [mainText]="banner.mainText"></ras-image-banner>
	<ras-top-banners [frontPage]="true"></ras-top-banners>

	<p align="center">More reasons to love Rent-a-Store | <a onclick="document.getElementById('reasons-to-love').scrollIntoView({behavior: 'smooth'})">Click here</a></p>

	<main>
		<h2>Choose a self storage location, find your unit and get a quick quote with an OTP</h2>

		<p>Reserve online with no obligation or reservation fees</p>

		<div class="choose-location">
			<div *ngFor="let item of locations | keyvalue">
				<ras-location-thumb [location]="item.value"></ras-location-thumb>
			</div>
		</div>

		<h2>Self storage</h2>

		<p>There is always a reason for more storage space. Whether you’re moving homes, renovating or simply looking to create more space in your office or home, Rent-A-Store has the ideal self-storage solution for you.</p>

		<p>Our storage units have been designed with our customer at heart. Each of our storage facilities offers a variety of differently sized storage units to suit almost every need.</p>

		<p>We know how stressful moving and reorganising can be and so we have made every part of your self-storage experience as easy as possible. You can now sign up directly from our website within 15 minutes, make use of our <a href="/free-move-in-transport">free move-in transport</a> solution, have flexibility in your storage lease duration and take advantage of our exciting self-storage specials.</p>

		<p>As a leading public storage facility in Gauteng, we pride ourselves in world-class <a href="/security">security</a> that ensures the safety of your valuables 24/7 while our friendly and skilled staff work passionately to ensure that you have the best self-storage experience possible.</p>
	</main>

<!--
	<ras-stand-alone-interactive-view-banner (generic_areas)="generic_areas = $event" (generic_sizes)="generic_units=$event" (small)="generic_unit_index=$event" (medium)="generic_unit_index=$event" (large)="generic_unit_index=$event" ></ras-stand-alone-interactive-view-banner>
	<ras-unit-interactive-view *ngIf="generic_units!=null" [agnostic_units]="generic_units[generic_unit_index]" [agnostic_area]="generic_areas[generic_unit_index]" [agnostic_index]="generic_unit_index" [all_units]="generic_units" (unit_index)="index_event($event)" (close)="generic_units=null"></ras-unit-interactive-view>
 -->

	<ras-reasons-to-love></ras-reasons-to-love>

	<ras-box-banner></ras-box-banner>

	<ras-testimonial></ras-testimonial>

</ras-page>
